import React from 'react';
import DesktopFooter from './desktop/desktop-footer';
import { IFooterProps } from './IFooter';
import MobileFooter from './mobile/mobile-footer';

const Footer = ({ footerProps }: IFooterProps): JSX.Element => {
  return (
    <>
      <MobileFooter footerProps={footerProps} className="block xl:hidden" />
      <DesktopFooter footerProps={footerProps} className="hidden xl:block" />
    </>
  );
};
export default Footer;
